module.exports = __webpack_public_path__ + "media/images/pages/i-belong/i_belong_icon-08e1f57686d3f4942bb846a64ebcd066.svg";